<template>
  <section>
    <input type="text" v-bind:value='model1' v-on:input="$emit('input1', $event.target.value)"  placeholder="批次">
    <span>——</span>
    <input type="text" v-bind:value='model2' v-on:input="$emit('input2', $event.target.value)"   placeholder="箱号">
  </section>
</template>

<script>
export default {
  props:['model1', 'model2'],
}
</script>

<style lang="less" scoped>
section {
    position: relative;
    display: inline-block;
    -webkit-appearance: none;
    background-color: #FFF;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;
    color: #606266;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: 0;
    width: 200px;
    position: relative;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        &>input {
            display: inline-block;
            position: relative;
            top: -1px;
            height: 36px;
            border: none;
            width: 94px;
            padding: 0 10px;
            box-sizing: border-box;
            text-align: center;
            -webkit-appearance: none;
            background-color: #FFF;
            background-image: none;
            color: #606266;
            font-size: 14px;
            border-radius: 4px;
            transition: border-color .2s cubic-bezier(.645,.045,.355,1);
        }
        &>input::-webkit-input-placeholder{
            color:#C0C4CC;
            font-size:15px;
            letter-spacing: 0;
        } 
        &>input:-moz-placeholder{
            color:#C0C4CC;
            font-size:16px;
            letter-spacing: 0;
        }
        &>input::moz-placeholder{
            color:#C0C4CC;
            font-size:16px;
            letter-spacing: 0;
        }
        &>input:-ms-input-placeholder{
            color:#C0C4CC;
            font-size:16px;
            letter-spacing: 0;
        }
        &>span{
            display: inline-block;
            width:10px;
            color:#C0C4CC;
        }
        &>input:focus {
            border: none;
            outline: none;
        }
}
section:focus-within {
    border-color:#409EFF !important;
}
section:hover {
    border-color: #C0C4CC;
}

</style>


